import type { CSSProperties } from 'react';
import { useTheme, type Theme } from '../hooks/useTheme.js';

const THEME_META: Record<Theme, { label: string; glyph: string; title: string }> = {
  hearth: { label: 'Світла', glyph: '☼', title: 'Світла тема (клік: → Темна)' },
  dark:   { label: 'Темна',  glyph: '☾', title: 'Темна тема — тепла умбра (клік: → Світла)' },
  light:  { label: 'Парчмент', glyph: '✦', title: 'Пергамент (резервна)' },
};

interface Props {
  /** Компактна версія — лише гліф, без лейблу */
  compact?: boolean;
  style?: CSSProperties;
}

export function ThemeSwitch({ compact = false, style }: Props): JSX.Element {
  const { theme, cycle } = useTheme();
  const meta = THEME_META[theme];
  return (
    <button
      type="button"
      onClick={cycle}
      title={meta.title}
      aria-label={`Тема: ${meta.label}. Клік — наступна.`}
      className="theme-switch"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        background: 'var(--bg-card)', border: '1px solid var(--border)',
        color: 'var(--gold)',
        padding: compact ? '5px 8px' : '7px 14px',
        borderRadius: 4,
        fontFamily: 'Cormorant Garamond, serif',
        fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.14em',
        cursor: 'pointer',
        ...style,
      }}
    >
      <span style={{ fontSize: 14, lineHeight: 1 }}>{meta.glyph}</span>
      {!compact && <span>{meta.label}</span>}
    </button>
  );
}
